export default function ArrowRight({
  className,
}: {
  className?: string
}) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 49 41" className={className} fill="#F2F2F2" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 23.6325V17.3675H36.8317L24.255 4.99799L28.7467 0.5L49 20.5L28.7467 40.5L24.0917 35.9217L36.6683 23.6325H0Z"/>
    </svg>
  )
}
